import React from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './Doc.scss';
import './Doc-media.scss';
import { IDoc } from './interfaces';
import { GetIconDoc } from './functions';
import { IconDownload } from './icons';

const Doc = ({ name, size, date, type, fileUrl }: IDoc) => {
  return (
    <a className="doc" href={fileUrl} download>
      {GetIconDoc(type)}
      <div className="doc__info">
        <p className="body2 doc__name">{name}</p>
        <p className="doc__size">{`${size}`}</p>
        <span className="doc__point"></span>
        <p className="doc__date">{date}</p>
      </div>
      {IconDownload}
    </a>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(Doc));
